export const isZeroFunding = (articleId: string): boolean => {
    const articlePromotions = getPromotionsForArticle(articleId);
    return articlePromotions.some(promotion => promotion.type === 'FEATURE' && promotion.couponType === 'PAYPAL_ZERO_FUNDING');
}